module.exports = __webpack_public_path__ + "img/blueEditSmall.889d3a9c.svg";